import { GetterTree } from 'vuex'
import decode from 'jwt-decode'
import _get from 'lodash/get'

import { AuthState } from './types'
import { RootState } from '../types'
import { Auth0UserProfile } from '../../types'

const AUTH0_TOKEN_AUTHORIZATION = process.env.VUE_APP_AUTH0_TOKEN_AUTHORIZATION

export const getters: GetterTree<AuthState, RootState> = {
  getAccessToken(state, moduleGetters): any {
    return state.accessToken
  },
  getLoggedIn(state, moduleGetters): any {
    if (!state.accessToken) return false
    const token = decode(state.accessToken)
    if (!token.exp) return null
    const currentTime = new Date().getTime() / 1000
    return currentTime < token.exp
  },
  getAuth0UserProfile(state): Auth0UserProfile | null {
    const decodedIdToken = decode(state.idToken)
    const decodedAccessToken = decode(state.accessToken)

    return {
      auth0Id: _get(decodedIdToken, 'sub') || '',
      email: _get(decodedIdToken, 'email') || '',
      email_verified: _get(decodedIdToken, 'email_verified') || false,
      name: _get(decodedIdToken, 'name') || '',
      nickname: _get(decodedIdToken, 'nickname') || '',
      picture: _get(decodedIdToken, 'picture') || '',
      roles: _get(decodedAccessToken, [AUTH0_TOKEN_AUTHORIZATION, 'roles']) || null,
    }
  },
  getUserInfo(state): any {
    return state.userInfo
  },
}
